import { render, staticRenderFns } from "./QuotaholdersOperationsFilters.vue?vue&type=template&id=106e5c9f&"
import script from "./QuotaholdersOperationsFilters.vue?vue&type=script&lang=js&"
export * from "./QuotaholdersOperationsFilters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports